"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _ConfirmModal = require("../../../../../../../ConfirmModal");
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _selectors = require("./store/selectors");
var _actions = require("./store/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LoginRequestButton = function LoginRequestButton(_ref) {
  var operatorID = _ref.operatorID,
    operatorName = _ref.operatorName;
  var ui = (0, _reactRedux.useSelector)(_selectors.getLoginRequestUI);
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onRequestLogin = (0, _react.useCallback)(function () {
    dispatch((0, _ConfirmModal.showConfirmModal)(function (isConfirmed) {
      return isConfirmed && dispatch((0, _actions.loginRequest)(operatorID));
    }, {
      header: t('LOGIN_REQUEST_MODAL_HEADER'),
      content: t('LOGIN_REQUEST_MODAL_CONTENT', {
        operatorName: operatorName
      })
    }));
  }, [dispatch, operatorID, operatorName, t]);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default.RenderWhen, {
    content: t('REQUEST_LOGIN_BUTTON_TOOLTIP'),
    isTrue: ui.completed,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    loading: ui.loading,
    disabled: ui.completed,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    theme: _Button.THEMES.GRAY,
    onClick: onRequestLogin
  }, t('REQUEST_LOGIN_BUTTON', {
    operatorName: operatorName
  })));
};
LoginRequestButton.propTypes = {
  operatorID: _propTypes.default.number.isRequired,
  operatorName: _propTypes.default.string.isRequired
};
var _default = exports.default = LoginRequestButton;